import { render, staticRenderFns } from "./RenderSearch.vue?vue&type=template&id=0b7e24de"
import script from "./RenderSearch.vue?vue&type=script&lang=js"
export * from "./RenderSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports